export enum TariffType {
  DELIVERY_COST_GAS = 'DELIVERY_COST_GAS',

  PURCHASE_FEE_GAS = 'PURCHASE_FEE_GAS',

  PURCHASE_PRICE_GAS = 'PURCHASE_PRICE_GAS',

  DELIVERY_COST_ELK = 'DELIVERY_COST_ELK',

  PURCHASE_PRICE_ELK = 'PURCHASE_PRICE_ELK',

  PURCHASE_FEE_ELK = 'PURCHASE_FEE_ELK',

  FEED_IN_ELK = 'FEED_IN_ELK',

  FEED_IN_FEE_ELK = 'FEED_IN_FEE_ELK',

  TAX_DISCOUNT_ELK = 'TAX_DISCOUNT_ELK',

  VAT = 'VAT',
}
